<template>
    <div class="bg">
      <BaseImg :option="{
        style: {
          margin: '12px 0 230px 16px',
          alignSelf: 'flex-start',
          width: '89px',
        },
        url: 'logo.png',
      }"/>
      <div class="name">
        <input type="text" placeholder="请输入核销码" @blur="blurInput" v-model="prizeCode" />
        <div class="submit" @click="scan">扫核销码</div>
        <div class="submit" @click="query">查 询</div>
        <div class="submit" @click="submit">核 销</div>
      </div>
      <!-- 弹窗 -->
      <div class="masks" v-show="showPrize">
        <!-- <div :style="{height: scrollTop}"></div> -->
        <div class="info">
          <div class="title">奖品详情</div>
          <div class="item">奖品名称:{{detail.prizeName}} </div>
          <!-- <div class="item">奖品描述:{{detail.orderDetail}} </div> -->
          <!-- <div class="item">手机号:{{detail.mobile}} </div> -->
          <div class="item">领奖地址:{{detail.addr}} </div>
          <div class="item">状态:{{detail.prizeStatus === '2' ? '未核销' : '已核销'}} </div>
          <span class="sclose" @click="showPrize = false">
            <img
              src="http://assets.rurushishi.com/activies/panda-game/close.png"
              alt
            />
          </span>
        </div>
      </div>
    </div>
</template>
<script>
let that = null;
import { MessageBox } from "mint-ui";
export default {
  data() {
    return {
      prizeCode: "",
      infoId: this.$config.infoId,
      isClick: false,
      showPrize: false,
      detail: {}
    };
  },
  components: {},
  methods: {
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      that.temporaryRepair();
    },
    scan() {
      // 扫码功能需要进router.js把核销页面的requiresAuth改为1，
      // 另外需要在@/services/act-wxjssdk.js中添加scanQRCode方法并导出才能使用
      let that = this;
      that.$wx.ready(() => {
        that.$wx.scanQRCode().then((res) => {
          console.log("微信扫码")
          let result = JSON.parse(res.resultStr);
          this.prizeCode = result.prizeCode
        })
      })
    },
    query() {
      if (!this.isClick) {
        this.isClick = true;
        if (!this.prizeCode) {
          return MessageBox.alert("请先输入核销码", "提示");
        }
        this.prizeCode = this.prizeCode.toLowerCase();
        let url = `/act-data/prizeWriteOff/prize/state`;
        this.$httpdf
          .get(
            url,
            {
              appId: this.$config.APPID,
              prizeCode: this.prizeCode,
            }
          )
          .then((data) => {
            if (data.code == 0) {
              console.log(data)
              this.showPrize = true
              this.isClick = false;
              this.detail = data.data
            } else {
              MessageBox.alert(data.msg)
              this.isClick = false;
            }
          });
      }
    },
    submit() {
      if (!this.isClick) {
        this.isClick = true;
        if (!this.prizeCode) {
          return MessageBox.alert("请先输入核销码", "提示");
        }
        this.prizeCode = this.prizeCode.toLowerCase();
        let url = `/act-data/prizeWriteOff/prize/writeOff`;
        this.$httpdf
          .post(
            url,
            {
              writeOffOpenId: "abc",   //核销人openId
              writeOffName: "admin",     //核销人昵称
              prizeCode: this.prizeCode,
              appId: this.$config.APPID,
            }
          )
          .then((data) => {
            if (data.code == 0) {
              return MessageBox.alert(
                `兑换成功！`,
                "提示"
              ).then(() => {
                this.isClick = false;
              });
            } else {
              return MessageBox.alert(data.msg, "提示").then(() => {
                this.isClick = false;
              });
            }
          });
      }
    },
  },
  created() {
    that = this;
  },
};
</script>
<style lang="scss" scoped>
.bg {
  background: url( $imgHost + 'index_top.png?v=' + $OSSVersion) 0 0 / 100% no-repeat, linear-gradient(0deg, #FAE5C7 0%, #F6C574 100%);
  .name {
    height: 50px;
    width: 70%;
    background: #fff;
    border-radius: 25px;
    margin-top: 20px;
  }
  input {
    color: #333;
    width: 92%;
    padding-left: 6%;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    background-color: transparent;
    border: none;
    &::-webkit-input-placeholder {
      color: #a9a9a9;
      font-size: 14px;
    }
  }
  .submit {
    position: relative;
    margin: 25px auto;
    width: 140px;
    height: 37px;
    background: #ED7750;
    box-shadow: 0px 1px 3px 0px rgba(235, 69, 62, 0.45);
    border-radius: 25px;
    @extend .flex-center-center;
    font-family: PingFangSC;
    font-weight: 500;
    color: #fff;
    font-size: 18px;
    letter-spacing: 4px;
    margin-bottom: 15px;
    text-align: center;
  }
  .masks {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .info {
      position: relative;
      width: 290px;
      background: #FFFFFF;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 20px;

      .title {
        font-size: 18px;
        color: #D80C18;
        font-family: PingFang SC;
        font-weight: bold;
        text-align: center;
        letter-spacing: 2px;
        margin-bottom: 20px;
      }

      .item {
        font-size: 12px;
        margin-bottom: 30px;
        line-height: 20px;
        width: 270px;
        // border-bottom: 1px solid #E9E9E9;
        align-items: center;
        color: #D80C18;
      }
    }

    .sclose {
      position: absolute;
      top: -40px;
      right: 0px;
      width: 20px;
      height: 20px;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>